<template>
  <BaseTableItemAction
    v-if="item.status=='closed'"
    v-can:[reopenPermission]
    v-on="$listeners"
    v-bind="$attrs"    
    icon="mdi-refresh"
    actionName="إعادة فتح الفرصة"
    @click="openJobReopenDialog()"
  >
    <ReopenJobDialog
      :showCondition="showReopenDialog"
      :item="item"
      @closed="closeJobReopenDialog"
    />
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_JOBS_PERMISSION } from "@/core/statics/Permissions";
import ReopenJobDialog from "../../dialogs/job_dialogs/ReopenJobConfirmationDialog.vue";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      reopenPermission:WRITE_JOBS_PERMISSION,
      showReopenDialog: false,
    };
  },
  methods: {
    openJobReopenDialog() {
      this.showReopenDialog = true;
    },
    closeJobReopenDialog() {
      this.showReopenDialog = false;
    },
  },
  components: { ReopenJobDialog },
};
</script>
